import {create} from 'zustand';
import {DocumentsService} from '../../api/generated/DocumentsService';
import {DocumentSummaryDto} from '../../api/generated/index.defs';

type CertificateStoreVariables = {
  certificate: DocumentSummaryDto | null;
  loading: boolean;
};

type CertificateStoreFunctions = {
  fetchCertificate: (jobId: number) => Promise<void>;
  clearCertificate: () => void;
};

type CertificateStore = CertificateStoreVariables & CertificateStoreFunctions;

const DEFAULT_VALUE: CertificateStoreVariables = {
  certificate: null,
  loading: false,
};

export const useCertificateStore = create<CertificateStore>((set) => {
  const fetchCertificate = async (jobId: number) => {
    set({loading: true});
    const {data} = await DocumentsService.getCertificateDocumentByJobId({
      id: jobId,
    });
    set({certificate: data, loading: false});
  };

  const clearCertificate = () => set({certificate: null});

  return {
    ...DEFAULT_VALUE,
    clearCertificate,
    fetchCertificate,
  };
});
